(() => {
  if (window.lbResponsiveSavings) return;
  const media = matchMedia('(max-width:768px)');
  function update(scope = document) {
    const cfg = window.LBSavings || {};
    scope.querySelectorAll('[data-lb-responsive-savings]').forEach(node => {
      const compare = Number(node.dataset.lbSavingCompare), price = Number(node.dataset.lbSavingPrice);
      const localShow = media.matches ? node.dataset.lbSavingMobileShow : node.dataset.lbSavingDesktopShow;
      const show = localShow === undefined ? (media.matches ? cfg.mobileShow : cfg.desktopShow) : localShow === 'true';
      if (!show || !(compare > price)) { node.hidden = true; return; }
      node.hidden = false;
      const kind = (media.matches ? node.dataset.lbSavingMobileType : node.dataset.lbSavingDesktopType) || (media.matches ? cfg.mobileType : cfg.desktopType);
      const amount = ['percent','percentage'].includes(kind) ? Math.round((compare-price)*100/compare)+'%' : window.theme?.Currency?.formatMoney(compare-price, theme.settings.moneyFormat);
      if (!amount) return;
      const html = (node.dataset.lbSavingLabel || cfg.label || '__LB_AMOUNT__').replace('__LB_AMOUNT__', amount);
      if (node.innerHTML !== html) node.innerHTML = html;
    });
  }
  document.addEventListener('variantChange', e => {
    const v = e.detail?.variant;
    if (!v || !(e.target instanceof Element)) return;
    const owner = e.target.closest('[data-product-id],.product-section') || e.target;
    owner.querySelectorAll('[data-lb-responsive-savings]').forEach(node => {
      node.dataset.lbSavingCompare = v.compare_at_price || 0;
      node.dataset.lbSavingPrice = v.price;
    });
    queueMicrotask(() => update(owner));
  }, true);
  media.addEventListener('change', () => update());
  document.addEventListener('shopify:section:load', () => update());
  document.addEventListener('quickview:loaded', () => update());
  document.addEventListener('DOMContentLoaded', () => update());
  window.lbResponsiveSavings = {update};
  update();
})();
